module.exports = __webpack_public_path__ + "img/ant.811395a1.svg";